import {Component, Input} from '@angular/core';
import {TileType32} from "../../../models";
import {
    ControlService,
    ParametersService,
    SubtitlesService,
} from "../../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'tile-disinfection',
    templateUrl: './tile-disinfection.component.html',
    styleUrls: ['./tile-disinfection.component.scss']
})
export class TileDisinfectionComponent {
    @Input() tile: TileType32;

    constructor(
        private control: ControlService,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    goControl() {
        if (this.tile.elementMenu) {
            this.$state.go('control', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
            this.control.setControl(this.tile.elementMenu);
        }
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }
}
